import { Outlet, useLocation } from "react-router-dom";
import Appbar from "../PortalSidebar/Appbar/AppbarTop";
import Sidebar from "../PortalSidebar/Sidebar/Sidebar";
import "../../styles.css";
import React, { useState } from "react";
const AppLayout = () => {
  const location = useLocation();
  const [toggle, settoggle] = useState(false);

  const handletoggle = () => {
    settoggle(!toggle);
  };
  return (
    <div
      className={location.pathname === "/layoutpreview" ? null : "applayout"}
    >
      <>
        {/* {location.pathname !== "/addnewpost" &&
        location.pathname !== "/editPost" &&
        location.pathname !== "/layoutpreview" ? ( */}
        {location.pathname === "/dashboard" || location.pathname === "/screens" ||  location.pathname === "/groups"? (
          <Appbar handletoggle={handletoggle} />
        ) : null}
        {location.pathname !== "/layoutpreview" ? (
          <Sidebar toggle={toggle} handletoggle={handletoggle} />
        ) : null}
      </>
      <Outlet />
    </div>
  );
};

export default AppLayout;
